import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../DataService/UserContext';

type ProtectedRouteProps = {
  // requiredRole?: 'admin' | 'member' | 'courseowner';
  requiredRole: string | string[];
  children: JSX.Element;
};

// const ProtectedRoute = ({ requiredRole, children }: ProtectedRouteProps) => {
//   const { user } = useUser();

//   if (!user) {
//     return <Navigate to="/sign-in" replace />;
//   }

//   if (requiredRole && !user.roles.includes(requiredRole)) {
//     return <Navigate to="/sign-in" replace />;
//   }

//   return children;
// };
const ProtectedRoute = ({ requiredRole, children }: ProtectedRouteProps) => {
  const { user } = useUser();
const roles = Array.isArray(requiredRole)
  ? requiredRole
  : [requiredRole];

const hasAccess = user?.roles.includes('admin') || roles.some(role =>
  user?.roles.includes(role)
);

  if (user === null) {
    return null;
  }

  if (requiredRole && /*!user?.roles.includes(requiredRole)*/!hasAccess) {
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};


export default ProtectedRoute;
